import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext, useState, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function Navigation() {
	const [open, setOpen] = useState(false)

	return (
		<div className={`sticky top-0 bg-ab-100 shadow`} style={{ zIndex: 20 }}>
			<div className="flex justify-end py-3 px-4">
				<button onClick={() => setOpen(!open)}>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-8 w-8 text-white">
						<path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
					</svg>
				</button>
			</div>
			<SlideOutMenu open={open} setOpen={setOpen} />
		</div>
	)
}

interface Props {
	open: boolean
	setOpen: (trueFalse: boolean) => void
}

function SlideOutMenu({ open, setOpen }: Props) {
	const { account } = useContext(CoreAdoptionContext)

	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="fixed inset-0 z-30 overflow-hidden" onClose={setOpen}>
				<div className="absolute inset-0 overflow-hidden">
					<Transition.Child
						as={Fragment}
						enter="ease-in-out duration-500"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in-out duration-500"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="absolute inset-0 bg-black bg-opacity-75 transition-opacity" />
					</Transition.Child>
					<div className="fixed inset-y-0 right-0 flex max-w-full pl-10">
						<Transition.Child
							as={Fragment}
							enter="transform transition ease-in-out duration-500 sm:duration-700"
							enterFrom="translate-x-full"
							enterTo="translate-x-0"
							leave="transform transition ease-in-out duration-500 sm:duration-700"
							leaveFrom="translate-x-0"
							leaveTo="translate-x-full"
						>
							<div className="relative w-screen max-w-[100vw] lg:max-w-[75vw] 2xl:max-w-[25vw]">
								<Transition.Child
									as={Fragment}
									enter="ease-in-out duration-500"
									enterFrom="opacity-0"
									enterTo="opacity-100"
									leave="ease-in-out duration-500"
									leaveFrom="opacity-100"
									leaveTo="opacity-0"
								>
									<div className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
										<button type="button" className="rounded-md text-white focus:outline-none focus:ring-2 focus:ring-white" onClick={() => setOpen(false)}>
											<span className="sr-only">Close panel</span>
											<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
											</svg>
										</button>
									</div>
								</Transition.Child>
								<div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
									<div className="relative mt-6 flex-1 px-4 sm:px-6">
										{/* Content */}
										<span className="mb-6 block text-3xl font-light">Quick Navigation</span>
										<ul>
											{account?.order
												.filter((o) => o.active)
												.filter((o) => o.show_in_nav)
												.map((o) => {
													return (
														<a
															key={o.id}
															onClick={() => setOpen(false)}
															className="mb-2 block border-b pb-4 text-gray-800 hover:no-underline"
															href={`#${formatSectionId(o)}`}
														>
															<li>
																<span className="font-semibold">{o.display_name ? o.display_name : o.name}</span>
																<span className="block text-sm text-gray-600">{o.description}</span>
															</li>
														</a>
													)
												})}
										</ul>
										{/* /End Content */}
									</div>
								</div>
							</div>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	)
}
